import { render, staticRenderFns } from "./FormTranProgramActivityReminderImport.vue?vue&type=template&id=909ee278&scoped=true"
import script from "./FormTranProgramActivityReminderImport.vue?vue&type=script&lang=js"
export * from "./FormTranProgramActivityReminderImport.vue?vue&type=script&lang=js"
import style0 from "./FormTranProgramActivityReminderImport.vue?vue&type=style&index=0&id=909ee278&prod&lang=scss&scoped=true"
import style1 from "./FormTranProgramActivityReminderImport.vue?vue&type=style&index=1&id=909ee278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909ee278",
  null
  
)

export default component.exports